/* Owl & Twig v11 — Sticky Nav + Scroll Reveal + Parallax */
/*
   v25 fix — scroll reveal was still blanking custom pages.

   History of this bug:
     v20: excluded elements INSIDE a .otg blog-article block.
     v21: also excluded wrappers CONTAINING .otg (the theme's own
          <div class="blog-post-content rte">).
     v25: neither guard helped custom pages like /pages/prowl, which are
          JS-heavy and carry no .otg class at all. Their content still sat
          inside a .rte wrapper, still got opacity:0, and still waited on an
          IntersectionObserver that may never fire on a tall page — so the
          page rendered blank on first load.

   Two changes:
     1. Scroll reveal is now skipped entirely on 'page' and 'article'
        templates. Those hold custom, self-styled content that ships its own
        layout and should never be hidden behind an observer. The animation
        still runs on the homepage, collections, and product pages, which is
        what it was built for.
     2. '.rte' is removed from the selector list. Hiding a whole content
        CONTAINER is the failure mode behind every version of this bug; its
        child headings, paragraphs and images still animate individually.
*/
(function () {
  'use strict';

  /* ---- STICKY NAV ---- */
  function initStickyNav() {
    var header = document.querySelector('header-component');
    if (!header) return;
    var threshold = 60;
    function onScroll() {
      if (window.scrollY > threshold) {
        header.classList.add('scrolled');
      } else {
        header.classList.remove('scrolled');
      }
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ---- SCROLL REVEAL ---- */
  function initScrollReveal() {
    // Skip custom-content templates entirely. theme.liquid renders
    // <main id="MainContent" data-template="{{ template }}">, so the current
    // template is readable here. Pages and articles opt out.
    var main = document.getElementById('MainContent');
    var template = (main && main.dataset.template) || '';
    if (template.indexOf('page') === 0 || template.indexOf('article') === 0) {
      return;
    }

    var targets = document.querySelectorAll('.shopify-section');
    targets.forEach(function (section) {
      // NOTE: '.rte' is deliberately absent below. Revealing a content
      // container hides everything inside it at once; its children are
      // matched individually instead.
      var children = section.querySelectorAll(
        'h1, h2, h3, p, .card-wrapper, .product-card-wrapper, .button, img, figure, .media'
      );
      children.forEach(function (el) {
        // Belt and braces: never touch custom blog-article layouts, in either
        // direction (element inside .otg, or wrapper containing .otg).
        if (el.closest('.otg') || el.querySelector('.otg')) return;
        el.classList.add('owt-reveal');
      });
    });

    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('owt-visible');
            observer.unobserve(entry.target);
          }
        });
      }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });

      document.querySelectorAll('.owt-reveal').forEach(function (el) {
        observer.observe(el);
      });
    } else {
      // Fallback: reveal all immediately
      document.querySelectorAll('.owt-reveal').forEach(function (el) {
        el.classList.add('owt-visible');
      });
    }
  }

  /* ---- PARALLAX HERO ---- */
  function initParallax() {
    var heroBg = document.querySelector('.owt-parallax-hero__bg');
    if (!heroBg) return;
    function onScroll() {
      var scrollY = window.scrollY;
      heroBg.style.transform = 'translateY(' + (scrollY * 0.35) + 'px)';
    }
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  /* ---- MARQUEE (duplicate items for seamless loop) ---- */
  function initMarquee() {
    document.querySelectorAll('.owt-marquee-track').forEach(function (track) {
      var items = track.innerHTML;
      // Duplicate for seamless looping
      track.innerHTML = items + items;
    });
  }

  /* ---- INIT ---- */
  document.addEventListener('DOMContentLoaded', function () {
    initStickyNav();
    initScrollReveal();
    initParallax();
    initMarquee();
  });
})();
